import { set, isEmpty } from 'lodash';

// eslint-disable-next-line no-undef
const APP_VERSION = __APP_VERSION__;

export const CONCEDO_AUTHN_PATH = '/concedoiam/v1/oauth/authorize';
export const DEFAULT_API_VERSION = 'v2';
export const CONFIG_PATH = '/configurations';
export const HOME_PATH = '/partners';
export const MYSTIQUE_COUNTRIES_CONFIG_PATH = '/api/v1/countries-config';
export const MYSTIQUE_PRODUCT_OFFERINGS_PATH = '/api/v1/product-offerings';
export const MYSTIQUE_ATTRIBUTES_PATH = '/api/v1/attributes';
export const MYSTIQUE_GENERATE_CONTENT_V1_PATH = '/api/v1/generate';
export const MYSTIQUE_GENERATE_CONTENT_V2_PATH = '/api/v2/generate';
export const DEFAULT_LOCALE = 'en';
export const MOCK_ALL_REQUESTS = false;
export const ENABLE_CONTENT_CONFIG_PORTAL = true;
export const ENABLE_CONTENT_PORTAL_PRODUCTS = true;
export const UCD_AUDIENCES_PATH = '/ucd/audiences';
export const UCD_AUDIENCES_LIST_PATH = `${UCD_AUDIENCES_PATH}/list`;
export const UCD_AUDIENCES_INFO_PATH = `${UCD_AUDIENCES_PATH}/info`;
export const DEFAULT_COUNTRY_ID = 4;
export const DEFAULT_TIMEZONE_OFFSET = 8;
export const DEFAULT_PAGE_SIZE = 20;
export const RELOGIN_THRESHOLD = 5 * 60; // 5 minutes
export const POLLING_SLEEP_DURATION = 5000; // ms
export const TOASTR_TIMEOUT = 10000; // ms
export const TOKEN_CHECK_INTERVAL = 60000; // ms

export const storageStateKey = 'reduxState';
export const maxFileSize = 500; // kbytes
export const maxImageSizeCover = [1242, 464]; // width x height px
export const maxImageSizeHero = [1125, 630]; // width x height px
export const maxImageSizeLogo = [260, 260]; // width x height px
export const maxImageSizeIcon = [500, 500];
export const imageSizeSectionCover = [700, 280]; // width x height px
export const supportedFileExtentions = ['jpg', 'jpeg', 'png'];
export const maxCSVFileSize = 2000; // kb
export const supportedCSVFileExtensions = ['csv'];

export const showControlGroup = false;

export const globalDefaultSearchParams = {
  pageSize: DEFAULT_PAGE_SIZE,
  page: 1,
};

export const getBaseUrl = (apiHost, apiPort) => {
  let baseUrl = `${window.location.protocol}//${apiHost}`;

  if (apiPort !== 80) {
    baseUrl = `${baseUrl}:${apiPort}`;
  }

  return baseUrl;
};

export const getApiBaseUrl = (version = DEFAULT_API_VERSION) => {
  const { API_BASE_PATH, API_BASE_URL } = window.Grab.config;
  const defaultApiBasePath = `/api/omega/${version}`;
  const apiBasePath = API_BASE_PATH || defaultApiBasePath;
  return `${API_BASE_URL}${apiBasePath}`;
};

export const getServiceBaseUrl = (serviceName) => {
  return window.Grab.config.EXTERNAL_SERVICES_BASE_URLS[serviceName];
};

/**
 * Attempts to load `config.json` file at root directory and add it to
 * window.Grab.config. Errors are swallowed and falls back to ansible templating.
 */
export const getConfigFile = async () => {
  const configResponse = await window.fetch(require('config.json'));

  if (configResponse.status !== 200) return;

  const config = await configResponse.json();

  if (isEmpty(config)) return;

  set(window, 'Grab.config', {
    ...window.Grab.config,
    ...config,
    API_BASE_URL: getBaseUrl(config.API_HOST, config.API_PORT),
  });
};

export const Config = {
  APP_VERSION,
  CONCEDO_AUTHN_PATH,
  MYSTIQUE_COUNTRIES_CONFIG_PATH,
  MYSTIQUE_PRODUCT_OFFERINGS_PATH,
  MYSTIQUE_ATTRIBUTES_PATH,
  MYSTIQUE_GENERATE_CONTENT_V1_PATH,
  MYSTIQUE_GENERATE_CONTENT_V2_PATH,
  MOCK_ALL_REQUESTS,
  ENABLE_CONTENT_CONFIG_PORTAL,
  ENABLE_CONTENT_PORTAL_PRODUCTS,
  DEFAULT_LOCALE,
  getApiBaseUrl,
  getServiceBaseUrl,
  globalDefaultSearchParams,
  getConfigFile,
  NAMESPACE: 'rtc',
};

// Set default config to global variable
set(window, 'Grab.config', Config);

export default Config;
